// extracted by mini-css-extract-plugin
export default {"commentForm":"DealerDocumentCommentForm_commentForm__ADXaC","submitButton":"DealerDocumentCommentForm_submitButton__vrPGB"};